<template>
  <div
    class="bg-white"
    :style="{ minHeight: `${height}px` }"
  >
    <div
      v-if="isLoading"
      class="flex items-center justify-center h-[80vh] bg-white"
    >
      <div class="text-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F95031] mx-auto mb-2" />
        <p class="text-gray-500">
          Memuat Desain Website...
        </p>
      </div>
    </div>
    <iframe
      v-show="!isLoading"
      ref="v2iframe"
      frameborder="0"
      :height="height"
      width="100%"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
      @load="handleLoad"
    />

    <b-modal
      id="modal-delete-template"
      ref="modal-delete-template"
      hide-header
      hide-footer
      centered
      body-class="p-0"
      content-class="border-0"
      style="border-radius: 16px; overflow: hidden;"
    >
      <div
        class="position-relative w-100 bg-white"
        style="padding: 24px; border-radius: 16px;"
      >
        <button
          class="position-absolute border-0 bg-transparent p-0"
          style="top: 24px; right: 24px; color: #828282; cursor: pointer; outline: none;"
          @click="$bvModal.hide('modal-delete-template')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="18"
              y1="6"
              x2="6"
              y2="18"
            />
            <line
              x1="6"
              y1="6"
              x2="18"
              y2="18"
            />
          </svg>
        </button>

        <div
          class="d-flex flex-column text-left"
          style="padding-right: 24px;"
        >
          <h2
            class="font-weight-bold m-0"
            style="font-size: 20px; color: #222222; line-height: 1.2; margin-bottom: 12px !important;"
          >
            Hapus Template?
          </h2>
          <p
            class="m-0"
            style="font-size: 16px; color: #737373; line-height: 1.5; margin-bottom: 24px !important;"
          >
            Template yang dihapus tidak dapat dikembalikan.<br>
            Apakah Anda yakin ingin menghapus template ini?
          </p>
        </div>

        <div class="d-flex justify-content-between align-items-center w-100">
          <button
            class="d-flex align-items-center justify-content-center"
            style="flex: 1; border-radius: 10px; padding: 10px; font-size: 15px; font-weight: 500; background-color: #F4F4F4; color: #222222; border: none; cursor: pointer; margin-right: 8px; outline: none;"
            @click="$bvModal.hide('modal-delete-template')"
          >
            Batal
          </button>
          <button
            class="d-flex align-items-center justify-content-center"
            style="flex: 1; border-radius: 10px; padding: 10px; font-size: 15px; font-weight: 500; background-color: #E31A1A; color: white; border: none; cursor: pointer; margin-left: 8px; outline: none;"
            @click="confirmDelete"
          >
            Ya, Hapus
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-apply-template"
      ref="modal-apply-template"
      hide-header
      hide-footer
      centered
      body-class="p-0"
      content-class="border-0"
      style="border-radius: 16px; overflow: hidden;"
    >
      <div
        class="position-relative w-100 bg-white"
        style="padding: 24px; border-radius: 16px;"
      >
        <button
          class="position-absolute border-0 bg-transparent p-0"
          style="top: 24px; right: 24px; color: #828282; cursor: pointer; outline: none;"
          @click="$bvModal.hide('modal-apply-template')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="18"
              y1="6"
              x2="6"
              y2="18"
            />
            <line
              x1="6"
              y1="6"
              x2="18"
              y2="18"
            />
          </svg>
        </button>

        <div
          class="d-flex flex-column text-left"
          style="padding-right: 24px;"
        >
          <h2
            class="font-weight-bold m-0"
            style="font-size: 20px; color: #222222; line-height: 1.2; margin-bottom: 12px !important;"
          >
            Terapkan Template?
          </h2>
          <p
            class="m-0"
            style="font-size: 16px; color: #737373; line-height: 1.5; margin-bottom: 24px !important;"
          >
            Template yang sedang aktif akan digantikan.<br>
            Perubahan yang belum disimpan akan hilang.
          </p>
        </div>

        <div class="d-flex justify-content-between align-items-center w-100">
          <button
            class="d-flex align-items-center justify-content-center"
            style="flex: 1; border-radius: 10px; padding: 10px; font-size: 15px; font-weight: 500; background-color: #F4F4F4; color: #222222; border: none; cursor: pointer; margin-right: 8px; outline: none;"
            @click="$bvModal.hide('modal-apply-template')"
          >
            Batal
          </button>
          <button
            class="d-flex align-items-center justify-content-center"
            style="flex: 1; border-radius: 10px; padding: 10px; font-size: 15px; font-weight: 500; background-color: #F95031; color: white; border: none; cursor: pointer; margin-left: 8px; outline: none;"
            @click="confirmApply"
          >
            Ya, Terapkan
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'EmbedDesainWebsite',
  data() {
    return {
      height: 900,
      isLoading: true,
      // Uses the same environment variable often used for v2 React app
      iframeSrc: `${process.env.VUE_APP_BASE_AUTH_MODULE}/komstore/desain-website`,
      templateIdToDelete: null,
      templateIdToApply: null,
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleLoad() {
      this.isLoading = false
    },
    handleMessage(event) {
      if (event.data?.type === 'komstore:delete-template-draft') {
        this.templateIdToDelete = event.data.payload.id
        this.$bvModal.show('modal-delete-template')
      } else if (event.data?.type === 'komstore:apply-template-draft') {
        this.templateIdToApply = event.data.payload.id
        this.$bvModal.show('modal-apply-template')
      } else if (event.data?.type === 'navigate') {
        this.$router.push(event.data.route)
      }
    },
    confirmDelete() {
      const iframe = this.$refs.v2iframe
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'komstore:confirm-delete-template-draft',
          payload: { id: this.templateIdToDelete },
        }, '*')
      }
      this.$bvModal.hide('modal-delete-template')
    },
    confirmApply() {
      const iframe = this.$refs.v2iframe
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'komstore:confirm-apply-template-draft',
          payload: { id: this.templateIdToApply },
        }, '*')
      }
      this.$bvModal.hide('modal-apply-template')
    },
  },
}
</script>

<style scoped>
/* Reset any margin/padding that might affect the iframe */
div, iframe {
  margin: 0;
  padding: 0;
  display: block;
}
</style>
